import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';
import BN_Asam4AssessmentSubdimension from './BN_Asam4AssessmentSubdimension';

export default class BN_Asam4AssessmentDimension extends BackboneElement {
    static __className = 'BN_Asam4AssessmentDimension';

    __objectStructure = {
        dimension: Number,
        subdimension: [BN_Asam4AssessmentSubdimension],
    };

    constructor(constructJson, className = 'BN_Asam4AssessmentDimension') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
